var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticStyle:{"max-width":"600px"},attrs:{"fluid":""}},[(_vm.poll != null)?_c('div',{staticClass:"text-left"},[_c('canvas',{attrs:{"id":"pie-div"}})]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }